import React from 'react'
import { ModalType, openModalTask } from '@src/components/modalComponent/modalComponent'
import { PRIVATE_USER_NAME } from '@src/utils/userUtils'
import { getUserAvatar } from '@src/utils/userUtils'
import { AvatarContainer, AvatarImage } from './Avatar.styled'
import { assetFixedSrcSet } from '../WebpLazyImage/WebpLazyImage.utils'

const DEFAULT_AVATAR = 'https://cdn.blackjack.fun/optimized/avatars/private.webp'

export interface AvatarProps {
  name: string
  uuid: string
  hasProfileImage: boolean
  noLink?: boolean
  size?: number
  forcePointer?: boolean
}

export const Avatar: React.FC<AvatarProps> = ({
  name,
  uuid,
  hasProfileImage,
  noLink = false,
  size = undefined,
  forcePointer = false,
}) => {
  const privateUser = name === PRIVATE_USER_NAME

  const handleClick = () => {
    if (!noLink && !privateUser) {
      openModalTask.next({ type: ModalType.userProfile, uuid })
    }
  }

  const getUserAvatarSrc = (name, hasProfileImage, privateUser, uuid) => {
    if (name === 'System') {
      return '/assets/chat/system.png'
    }
    if (privateUser) {
      return DEFAULT_AVATAR
    }
    return hasProfileImage ? `/api/avatar/user/${uuid}` : getUserAvatar(uuid)
  }

  // Handle image loading error
  const handleError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.src = DEFAULT_AVATAR
  }

  const isClickable = !noLink && !privateUser && name !== 'System'
  const showPointer = isClickable || forcePointer
  const src = getUserAvatarSrc(name, hasProfileImage, privateUser, uuid)

  return (
    <AvatarContainer size={size}>
      <AvatarImage
        alt="user-avatar"
        src={src}
        width={size}
        srcSet={assetFixedSrcSet({
          url: src,
          originalWidth: 400,
          width: size || 80,
        })}
        clickable={showPointer}
        onError={handleError}
        onClick={isClickable ? handleClick : undefined}
        hasProfileImage={hasProfileImage}
      />
    </AvatarContainer>
  )
}
